import React from 'react'
import toast from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import routes from '../../../helpers/routes';
import { SellOrderContext } from '../../../providers/SellOrdersProvider';
import { createSellOrder } from '../../../utils/api/sellOrders';
import OrderForm from '../orders/OrderForm';
import { ContactModal } from './ContactModal';

const Conatiner = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  overflow-y: scroll;
`

function NewSellOrder() {
  const { fetch } = React.useContext(SellOrderContext);
  const history = useHistory();
  const [showContactModal, setShowContactModal] = React.useState(false);
  const [pendingOrder, setPendingOrder] = React.useState<any>(null);

  const createOrder = (order: any) => {
    createSellOrder(order)
      .then((response) => {
        fetch();
        toast.success(response.data.state === 'pending_review' ? "Venta enviada a revisión" : "Orden registrada");
        history.push(routes.ventas.index);
      })
      .catch((e: any) => {
        if (e.response?.data?.code === 'CLIENT_WITHOUT_CONTACTS') {
          setPendingOrder(order);
          setShowContactModal(true);
          return;
        }

        toast.error(e.response?.data?.message || 'Error al crear la orden');
      });
  }

  return (
    <Conatiner>
      <h1>Nueva Orden de venta</h1>
      <OrderForm submitFunction={createOrder} disabled={showContactModal} />
      <ContactModal
        open={showContactModal}
        onClose={() => setShowContactModal(false)}
        customerId={pendingOrder?.customerId}
        onSaved={async () => {
          setShowContactModal(false);
          createOrder(pendingOrder);
        }}
      />
    </Conatiner>
  )
}

export default NewSellOrder